import Vue from "vue";
import NetworkCableCalculator from "./components/network-cable-calculator/NetworkCableCalculator.vue";

if (document.querySelector("#network-cable-calculator-app")) {
  new Vue({
    el: "#network-cable-calculator-app",
    components: {
      NetworkCableCalculator
    }
  });
}
